export enum VisitMethods {
  VIDEO = 'video',
  CALL = 'call',
  INPERSON = 'inperson',
  ASYNCHRONOUS = 'asynchronous',
}
